'use client'

import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

import { nextLinkHrefFromPathWithOptionalHash } from '@/_lib/next-link-href'
import { handleProgramaticScroll } from '@/_lib/utils'
import { processLink } from '@/_utils/link.utils'

interface IHeroCardButton {
	text: string
	href: string
	className?: string
	icon?: string
	hideIcon?: boolean
}

interface IHeroCardProps {
	title: string | string[]
	cardText: string | string[]
	buttons?: IHeroCardButton[]
	/** When set, buttons are wrapped in a row container (e.g. flex). Omit to keep legacy layout. */
	buttonsRowClassName?: string
}

const ZHeroCard: React.FC<IHeroCardProps> = ({
	title,
	cardText,
	buttons,
	buttonsRowClassName
}) => {
	const renderTitle = () => {
		return Array.isArray(title)
			? title.map((line, idx) => (
					<React.Fragment key={idx}>
						{line}
						{idx < title.length - 1 && <br />}
					</React.Fragment>
				))
			: title
	}

	const renderCardText = () => {
		return Array.isArray(cardText) ? (
			cardText.map((text, idx) => (
				<p key={idx} dangerouslySetInnerHTML={{ __html: text }}></p>
			))
		) : (
			<p dangerouslySetInnerHTML={{ __html: cardText }}></p>
		)
	}

	const getArrowIcon = (isExternal: boolean) => {
		return isExternal ? 's_ar2_r' : 's_ar2_rd'
	}

	const heroButtons =
		buttons?.length ?
			buttons.map((button, idx) => {
				const linkProps = processLink(button.href)
				const isExternal = linkProps.target === '_blank'
				const arrowIcon = button.icon || getArrowIcon(isExternal)

				return (
					<Link
						key={idx}
						{...linkProps}
						href={
							isExternal
								? linkProps.href
								: nextLinkHrefFromPathWithOptionalHash(linkProps.href)
						}
						className={clsx(
							button.className || 'btn_basic type5',
							arrowIcon === 's_ar2_rd' && 'hover-1'
						)}
						prefetch={false}
						onClick={handleProgramaticScroll}
					>
						<span>{button.text}</span>
						{!button.hideIcon && (
							<span>
								<span>
									<svg className='sico'>
										<use href={`/assets/layout/icons.svg#${arrowIcon}`} />
									</svg>
								</span>
								<span>
									<svg className='sico'>
										<use href={`/assets/layout/icons.svg#${arrowIcon}`} />
									</svg>
								</span>
							</span>
						)}
					</Link>
				)
			})
		: null

	return (
		<>
			<h1 className='title_h1'>{renderTitle()}</h1>

			<div
				className='page_content reset_margins nobalance mgt-30 mgt-20lg show_lgm truncate_content text-center '
				data-truncate-length='135'
				data-truncate-show='viac'
				data-truncate-hide='menej'
			>
				{renderCardText()}
			</div>
			<div className='page_content reset_margins nobalance mgt-30 mgt-20lg hide_lgm text-left mx-auto'>
				{renderCardText()}
			</div>
			{heroButtons ?
				buttonsRowClassName ?
					<div className={buttonsRowClassName}>{heroButtons}</div>
				:	heroButtons
			:	null}
		</>
	)
}

export default ZHeroCard
